<style>
.menu-opened body:before {
  display: none;
}
</style>
<template>
  <div class="authendication-pages">
    <!-- Page Content -->
    <div class="content">
      <div class="container wrapper no-padding">
        <div class="row no-margin vph-100">
          <div class="col-12 col-sm-12 col-lg-6 no-padding">
            <div class="banner-bg login">
              <div class="row no-margin h-100">
                <div class="col-sm-10 col-md-10 col-lg-10 mx-auto">
                  <div
                      class="h-100 d-flex justify-content-center align-items-center"
                  >
                    <div class="text-bg register text-center">
                      <button
                          class="btn btn-limegreen text-capitalize"
                          type="button"
                      >
                        <i class="fa-solid fa-thumbs-up me-3"></i>Đăng nhập
                      </button>
                      <p>
                        Để quản lý thông tin vận động viên và thứ hạng của mình,
                        vui lòng đăng nhập vào hệ thống.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-sm-12 col-lg-6 no-padding">
            <div class="dull-pg">
              <div
                  class="row no-margin vph-100 d-flex align-items-center justify-content-center"
              >
                <div class="col-sm-10 col-md-10 col-lg-10 mx-auto">
                  <header class="text-center">
                    <router-link to="/">
                      <img
                          alt="Logo"
                          class="img-fluid"
                          src="@/assets/img/logo_red.png"
                      />
                    </router-link>
                  </header>
                  <div class="shadow-card">
                    <h2>Chào mừng bạn quay trở lại</h2>
                    <p>Đăng nhập vào tài khoản của bạn</p>

                    <div id="myTabContent" class="tab-content">
                      <div
                          id="user"
                          aria-labelledby="user-tab"
                          class="tab-pane fade show active"
                          role="tabpanel"
                      >
                        <!-- Login Form -->
                        <Form
                            v-slot="{ errors }"
                            :validation-schema="schema"
                            @submit="onSubmit"
                        >
                          <div class="form-group">
                            <div class="group-img">
                              <i class="feather-user"></i>
                              <Field
                                  v-model="email"
                                  :class="{ 'is-invalid': errors.email }"
                                  class="form-control"
                                  name="email"
                                  type="text"
                              />
                              <div class="invalid-feedback">
                                {{ errors.email }}
                              </div>
                              <div
                                  id="email"
                                  class="emailshow text-danger"
                              ></div>
                            </div>
                          </div>
                          <div class="form-group">
                            <div class="pass-group group-img">
                              <Field
                                  v-model="password"
                                  :class="{ 'is-invalid': errors.password }"
                                  :type="showPassword ? 'text' : 'password'"
                                  class="form-control pass-input mt-2"
                                  name="password"
                              />
                              <span class="toggle-password" @click="toggleShow">
                                <i
                                    :class="{
                                    'fas fa-eye': showPassword,
                                    'fas fa-eye-slash': !showPassword,
                                  }"
                                ></i>
                              </span>
                              <div class="invalid-feedback">
                                {{ errors.password }}
                              </div>
                              <div
                                  id="password"
                                  class="emailshow text-danger"
                              ></div>
                            </div>
                          </div>
                          <div class="form-group d-sm-flex align-items-center justify-content-end">
                            <span><router-link
                                class="forgot-pass"
                                to="/forgot-password">Quên mật khẩu</router-link></span>
                          </div>
                          <p v-if="errorMessage"
                             class="text-danger text-center mt-2">
                            {{ errorMessage }}
                          </p>
                          <button
                              class="btn btn-secondary register-btn d-inline-flex justify-content-center align-items-center w-100 btn-block"
                              type="submit">
                            Đăng nhập<i class="feather-arrow-right-circle ms-2"></i>
                          </button>
                          <div class="form-group">
                            <div class="login-options text-center">
                              <span class="text">Hoặc tiếp tục với</span>
                            </div>
                          </div>
                          <div class="form-group mb-0">
                            <ul
                                class="social-login d-flex justify-content-center align-items-center"
                            >
                              <li class="text-center">
                                <button class="btn btn-social d-flex align-items-center justify-content-center"
                                        type="button"
                                        @click="loginWithGoogle"
                                >
                                  <img
                                      alt="Google"
                                      class="img-fluid"
                                      src="@/assets/img/icons/google.svg"
                                  />
                                  <span>Google</span>
                                </button>
                              </li>
                            </ul>
                          </div>
                        </Form>
                        <!-- /Login Form -->
                      </div>
                    </div>
                  </div>
                  <div class="bottom-text text-center">
                    <p>
                      Bạn không có tài khoản?
                      <router-link to="/register">Đăng ký ngay!</router-link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->
  </div>
</template>
<script setup>
import {ref} from 'vue'
import {Form, Field} from 'vee-validate'
import {useAuthStore} from '@/stores/auth'
import userService from "@/stores/user";

const showPassword = ref(false)
const email = ref('')
const password = ref('')
const errorMessage = ref('')

const toggleShow = () => {
  showPassword.value = !showPassword.value
}

const authStore = useAuthStore()

const onSubmit = async () => {
  try {
    await authStore.login(email.value, password.value)
  } catch (error) {
    errorMessage.value = error || 'Có lỗi xảy ra!'
  }
}

const loginWithGoogle = async () => {
  try {
    const res = await userService.loginGoogle();
    window.location.href = res.data.url;
  } catch (error) {
    errorMessage.value = error || 'Có lỗi xảy ra!'
  }
}
</script>
